class masonry {
	margin = [0, 0];
	constructor() {
		this.items = document.querySelectorAll('[data-page-handle="method"] .method--grid .method--grid-item');
		if (this.items.length === 0) return;

		for (const i in [...this.items]) {
			this.subtractionMargin(i);
		}
	};

	subtractionMargin(i) {
		const item = this.items[i];
		const n = i % 2;

		item.style.marginTop = `${this.margin[n]}px`;

		const height1 = item.getBoundingClientRect().height;
		const height2 = item.querySelector('.content').getBoundingClientRect().height;

		this.margin[n] -= (height1 - height2);
	};
};


class accordion {
	constructor() {
		this.wrapper = document.querySelector('.accordion');
		if (this.wrapper === null) return;

		this.containers = this.wrapper.querySelectorAll('.accordion--container');
		for (const container of [...this.containers]) {
			container._height1 = container.getBoundingClientRect().height;
			container._height2 = container._height1 / 2;
			Object.assign(container.style, { height: `${container._height2}px`, overflow: 'hidden', transition: '0.3s ease' });
		}

		this.trigger = this.wrapper.querySelector('.accordion--trigger');
		this.trigger.addEventListener('click', e => {
			e.preventDefault();

			for (const container of [...this.containers]) {
				container.style.height = 'auto';
			}

			this.trigger.remove();

			const offset = (() => {
				const header = document.querySelector('#shopify-section-header');
				const style = window.getComputedStyle(header);
				return header.getBoundingClientRect().height + +style.top.replace('px', '') + 20;
			})();

			const top = this.wrapper.getBoundingClientRect().top + window.pageYOffset - offset;
			window.scrollTo({ behavior: 'smooth', top });
		});
	};
};

{
	let currentWidth = window.innerWidth;

	window.addEventListener('resize', () => {
		if (currentWidth == window.innerWidth) {
			return;
		}

		currentWidth = window.innerWidth;
		
		// new masonry;
		new accordion;
	});
	window.addEventListener('load', () => {
		// new masonry;
		new accordion;
	});
};